module.exports = __webpack_public_path__ + "media/theme/tutorial__itunes--7--b-2b2d0000.png";